import React from "react";
import { Grid, Typography, useMediaQuery } from "@material-ui/core";
import { useSelector } from "react-redux";
import { getSocietyTimezone } from "@icarius-app/selectors";
import { language } from "@icarius-localization/strings";
import { getTime } from "@icarius-common/clock/selectors";

const toTitleCase = (str) => {
    return str.replace(/\w\S*/g, function(txt) {
        if (txt === "de") return txt;
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
};

const Clock = () => {
    const societyTimezone = useSelector(getSocietyTimezone);
    const time = useSelector(getTime);

    const timezone = societyTimezone || Intl.DateTimeFormat().resolvedOptions().timeZone;
    const locale = language !== "es" ? "en-US" : "es-ES";

    const isMoreOrEqualsThan960 = useMediaQuery(`(min-width: 960px)`);

    return (
        <Grid container item sm={12} md={6} justify={isMoreOrEqualsThan960 ? "flex-end" : "flex-start"}>
            <Typography className="whiteText myDesktopClockText myDesktopClockTextAlt">
                {toTitleCase(
                    new Date(time).toLocaleDateString(locale, {
                        timeZone: timezone,
                        weekday: "long",
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                    })
                )}
                ,
            </Typography>
            <Typography className="whiteText myDesktopClockText">
                {new Date(time).toLocaleTimeString("en-US", {
                    timeZone: timezone,
                    hour12: false,
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                })}
            </Typography>
        </Grid>
    );
};

export default Clock;
